   class AppConfigService {
       getApiUrl(){
           return "https://agenda-api.docleas.eu";
       }
   }
